/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { c, classes } from '@minds/minds-react-sdk';
import { forwardRef } from 'react';
import style from './checkbox.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    wrapperClassName?: string;
}

function Checkbox(
    { className, wrapperClassName, ...props }: Props,
    ref: React.ForwardedRef<HTMLInputElement>,
) {
    return (
        <div className={c(style.checkboxContainer, wrapperClassName)}>
            <label
                className={c('form-check-label', style.label, className)}
                htmlFor={props.id}
                data-testid="checkboxLabel"
                color={props.color}
                onMouseDown={(e) => e.preventDefault()}
            >
                <input
                    className={classes([
                        'form-check-input',
                        style.checkboxInput,
                        className,
                    ])}
                    {...props}
                    ref={ref}
                    type="checkbox"
                />
                {props.label}
            </label>
        </div>
    );
}

export default forwardRef(Checkbox);
